import $ from "/Users/abdullahbendahman/Sites/emonta/wp-content/plugins/wp-soup-framework/node_modules/jquery";
import { Foundation } from "/Users/abdullahbendahman/Sites/emonta/wp-content/plugins/wp-soup-framework/node_modules/foundation-sites/js/foundation.core";
import { OffCanvas } from '/Users/abdullahbendahman/Sites/emonta/wp-content/plugins/wp-soup-framework/node_modules/foundation-sites/js/foundation.offcanvas'
Foundation.plugin(OffCanvas, 'OffCanvas')

import Swiper, {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  Thumbs,
  Controller,
  EffectCoverflow,
} from "/Users/abdullahbendahman/Sites/emonta/wp-content/plugins/wp-soup-framework/node_modules/swiper";

Swiper.use([
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  Thumbs,
  Controller,
  EffectCoverflow,
]);

function equalizeHeight(container) {
  let currentTallest = 0;
  let currentRowStart = 0;
  const rowDivs = new Array();
  let topPosition = 0;
  $(container).each(function () {
    const $el = $(this);
    $($el).height("auto");
    topPosition = $el.position().top;

    if (currentRowStart !== topPosition) {
      for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPosition;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest =
        currentTallest < $el.height() ? $el.height() : currentTallest;
    }
    for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}

function equalizeSliders() {
  const screenSize = $(window).width();
  $(".ms_products_slider").each(function () {
    const details = $(this).find(".details");


    if (screenSize > 500) {
      equalizeHeight(details);
    }
  });
}

$(window).on("load", function () {
  equalizeSliders();
  window.dispatchEvent(new Event("resize"));
});

$(window).on("resize", function () {
  equalizeSliders();
});

$(document).ready(function () {
  const slider = document.querySelector(".ms_products_slider .product-slider");
  if (slider) {
    let options = slider.dataset.sliderOptions;
    options = JSON.parse(options);

    const productSlider = new Swiper(
      ".ms_products_slider .product-slider",
      options
    );
  }

  const webshopThumbs = new Swiper(".webshop-thumbs", {
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesPerView: 3,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: "vertical",
  });

  const webshopMain = new Swiper(".webshop-main", {
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".webshop-pagination",
      type: "bullets",
      clickable: true,
    },
    autoplay: {
      delay: 5000,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: webshopThumbs,
    },
  });

  webshopMain.on("slideChangeTransitionStart", function () {
    webshopThumbs.slideTo(webshopMain.activeIndex);
  });
  webshopThumbs.on("transitionStart", function () {
    webshopMain.slideTo(webshopThumbs.activeIndex);
  });

  // Select the target node.
  const shopGrid = document.querySelector(".wpgb-content-producten");
  const screenSize = $(window).width();
  if (screenSize > 600) {
    if (shopGrid !== null) {
      // Create an observer instance.
      const observer = new MutationObserver(async function (mutations) {
        for (const mutation of mutations) {
          const node = mutation.target;
          if (node.className.includes("wpgb-loading")) {
            continue;
          }

          await new Promise((r) => setTimeout(r, 100));

          const grid = $(".wpgb-content-producten > ul");
          new Foundation.Equalizer(grid);

          grid.each(function () {
            const details = $(this).find(".details");
            equalizeHeight(details);
          });
        }
      });

      // Pass in the target node, as well as the observer options.
      observer.observe(shopGrid, {
        attributes: true,
      });
    }
  }
});

/**
 * Hide initial price on product page when #verpakkingen and #pa_interval is set.
 */
$(document).ready(function () {
  $('#verpakkingen, #pa_interval').change(function () {
    if ($('#verpakkingen').val() && $('#pa_interval').val()) {
      $('.prices').hide();
    }
  });
});